import styles from "./index.module.css";
const Button = ({ children,className,href ,size}) => {
  return <a className={`${styles.button} ${className} ${size ? styles[size] : ''}`} href={href} data-cursor-size="80px">{children}</a>;
};

export default Button